module.exports = __webpack_public_path__ + "static/img/sy_cqd.1b49c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sy/sy_cqd.png
// module id = jVzi
// module chunks = 1